import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function descargarficherofacturasexcel (params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(mock.getLanguages.data)
      }, 500)
    })
  } else {
    const req = {
      url: '/api/facturas/descargarficherofacturasexcel',
      method: 'GET',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      responseType: 'blob',
      params
    }
    const res = await axiosInstance(req)
    const response = {
      data: res.data,
      headers: res.headers
    }
    return response
  }
}

export { descargarficherofacturasexcel }
